import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { Contacto } from 'src/app/global/interfaces/contacto';
import { ContactoService } from 'src/app/global/services/contacto.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class ContactoProvider extends ContactoService {

    private baseUrl = _.get(environment, 'api.host', '');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints');
    private endpoint: string;


    constructor(private http: HttpClient) {
        super();
    }

    /**
     * Obtiene los datos de contacto para agendamiento de entrega
     * @returns Datos registrados con el contacto para agendamiento de entrega o error en caso contrario
     */
    public getContactoAgendamiento(): Observable<Contacto> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.CONTACTO_AGENDAMIENTO', '');

        return this.http.get<Contacto>(this.endpoint);
    }

    /**
     * Guarda la información proporcionada del contacto que recepcionará los productos.
     * @param datosContacto Objeto tipo Contacto con la información del contacto que recibirá los productos
     * @returns Respuesta OK con el registro de los datos o error en caso contrario
     */
    public postContactoAgendamiento(datosContacto: Contacto): Observable<any> {

        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.CONTACTO_AGENDAMIENTO', '');

        return this.http.post(this.endpoint, datosContacto);

    }
}
